import React, { useCallback } from 'react'

import Component from './component'

const Container = ({ isPopup, company }) => {
  const validateCodeLength = useCallback((value) => value && value.length < 4 ? 'voucher.error.code_min_length' : undefined, [])
  const getStatusOptionProps = useCallback((props) => ({ _typography: { color: !!props?.value ? 'green' : 'orange' } }), [])

  const mutateCompanyService = useCallback((elem) => {
    const parts = isPopup
      ? [elem?.contract?.client_id, elem?.client_id]
      : [elem?.contract?.company?.name, elem?.contract?.client_id, elem?.client_id]
    return { label: _.join(_.compact(parts), ' - '), ...elem }
  }, [isPopup])

  const autocompleteQueryMutator = useCallback((q) => ({
    or: isPopup
      ? [{ client_id: q }, { contract: { client_id: q } }]
      : [{ client_id: q }, { contract: { client_id: q } }, { contract: { company: { name: { contains: q } } } }]
  }), [isPopup])

  const validateCompanyFilter = useCallback(() => !!company, [company])
  const companyserviceLabel = isPopup ? 'voucher.contract_service' : 'voucher.company_contract_service'
  const companyserviceConfig = isPopup
    ? {
      initial_filter: { contract: company },
      forced_filter: { contract: { company } },
      validate_filter: validateCompanyFilter,
      watchers: [company],
      populate: ['contract'],
      mutator: mutateCompanyService
    }
    : {
      populate: ['contract.company'],
      mutator: mutateCompanyService
    }

  const mergedProps = {
    isPopup,
    companyserviceLabel,
    companyserviceConfig,
    autocompleteQueryMutator,
    validateCodeLength,
    getStatusOptionProps,
  }

  return <Component {...mergedProps} />
}

export default Container
